export default __webpack_public_path__ + "static/media/AcornMallCarpark_30.7697bd52.png";